export const configurationKeys = {
  fileExtensions: ['fileExtensions'] as const,
  privateViewsLimit: (indexId?: number) => ['privateViewsLimit', indexId] as const,
  globalFiltersLimit: (indexId?: number) => ['globalFiltersLimit', indexId] as const,
  multiFileUploadLimit: (indexId?: number) => ['multiFileUploadLimix', indexId] as const
};
